export * from './analytics'
export * from './countries'
export * from './deliveryCompanies'
export * from './magicNumbers'
export * from './options'
export * from './pillars'
export * from './routes'
export * from './redux'
export * from './tooltips'

// Uniq resources
export const FIIT_ACCENTURE_ID = 'act_l5ziu9p0lyrbzdmsaopeh6p8aqw9i993'
export const FIIT_FAMILY_OFFER_ACCENTURE_ID = 'act_2c55bb30-9dcb-11eb-8038-5fd7fe3fadda'

// Used: App
export const LINKS = {
    IOS_APPSTORE: 'https://apps.apple.com/us/app/betterspace/id1492803107',
    ANDROID_MARKET: 'market://details?id=uk.betterspace.fuli',
}

// Messages for different error cases
export const ERROR_MESSAGES = {
    default: 'Something went wrong...',
    ['Not enough data yet!']: 'Not enough data yet!',
    ['No data for this department']: 'Not enough data for this department',
    NICKNAMES:
        'Nicknames cannot be updated at the moment due to an error. Please try refreshing the page or email support@betterspace.uk if the error still persists.',
    ['Vouchers having duplicate codes']: 'Vouchers having duplicate codes',
}

// Used: S/Settings
export const PERMITIONS_KEYS = {
    PERMITION_TO_VIEW: 'accessToPages',
    EMAIL_NOTIFICATION: 'emailNotifications',
}

// Used U&A.
export const LISTS_KEYS = {
    filterTagsByPillar: 'filterTagsByPillar',
    type: 'type',
    typeOfEngagement: 'typeOfEngagement',
}

// Used U&A.
export const TRANSACTION_STATE = {
    ADDING_BUDGET: 'ADDING_BUDGET',
    ERROR: 'ERROR',
    FETCHING: 'FETCHING',
    NONE: 'NONE',
    START: 'START',
    SUCCESS: 'SUCCESS',
}

// Used U/WAU
export const POSITIVE_QUESTION = {
    Linklaters: 'Do you feel your experience at Linklaters is positively impacting your wellbeing?',
    Accenture: 'Do you feel there’s a senior person at work who genuinely cares about your wellbeing?',
    default: 'Do you feel your employment is positively impacting your wellbeing?',
}

// Used U/WAU
export const SATISFACTION_QUESTION = 'Overall, how satisfied are you with your life nowadays?'

// Used U&A/Assesment
export const ANSWERS = {
    NUMBER: 'NUMBER',
    PILLAR_GOALS: 'PILLAR_GOALS',
    RANKING: 'RANKING',
    LIKERT_TEXT: 'LIKERT_TEXT',
    LIKERT_NUMBER: 'LIKERT_NUMBER',
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    SINGLE_CHOICE: 'SINGLE_CHOICE',
    CONTINUE_BUTTON: 'CONTINUE_BUTTON',
    TEXT: 'TEXT',
    PILLAR_LIST: 'PILLAR_LIST',
    SUMMARY: 'SUMMARY',
}

// Used for budgetSetup on FE/BE
export const BUDGET_MODELS = {
    USE_OR_LOSE: 'USEORLOSE',
    ACCUMULATION: 'ACCUMULATION',
    MIX: 'MIX',
}
export const RESET_FREQUENCY = {
    1: { value: 'MONTH', label: 'One month' },
    2: { value: 'TWO_MONTHS', label: 'Two months' },
    3: { value: 'QUARTER', label: 'Three months' },
    6: { value: 'SIX_MONTHS', label: 'Six months' },
    12: { value: 'YEAR', label: 'Twelve months' },
}
